module.exports = __webpack_public_path__ + "media/images/icons/outlined/play-square-e4a2812710a5e9cb31729ec11cb6280d.svg";